/**
 * お気に入りハートの状態表示 + 操作の肩代わり (No.78, 2026-08-17 v5.2)
 *
 * 背景（すべて実測）: ストア側テンプレート破損
 * (Unclosed section "multipleLists") の影響で、Swym のハートボタンは
 *   1. 読み込み時から内部状態が壊れる（保存済み商品でも「未追加モード」+
 *      atw-button-loading が固着）
 *   2. クリックすると通信は走るが、保存リストが変化しない
 *      （保存済み商品をクリックしても削除されない = 「消せない」の正体）
 * つまり見た目だけでなく追加/削除の操作そのものが壊れている。
 *
 * 本実装（Swym サポートがテンプレートを修復するまでの仮組み）:
 * - クリックを壊れたボタン処理へ渡さず、公開 JS API で肩代わりする
 *   （サーバーの実リストを読み、入っていれば removeFromWishList /
 *     入っていなければ addToWishList）
 * - 塗り (.nicomore-hearted) と処理中表示 (.nicomore-heart-busy) は
 *   常にサーバーの実リスト基準。アプリ内部の DOM・CSS には手を入れない。
 * - Swym 修復後はこのファイルを撤去すれば元の動作に戻る。
 *
 * v4 からの継承: このストアの Swym は SwymCallbacks 配列を消費しない
 * （12件未消費を実測）ため、window._swat をポーリングで直接待ち受ける。
 */
(function () {
  'use strict';

  var started = false;

  function start(swat) {
    if (started) return;
    started = true;

    var busy = false;

    function productId() {
      try {
        if (window.ShopifyAnalytics && ShopifyAnalytics.meta.product) {
          return String(ShopifyAnalytics.meta.product.id);
        }
      } catch (err) { /* 取得不能ページでは何もしない */ }
      return null;
    }

    function variantId() {
      var el = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (el && el.value) return String(el.value);
      try { return String(ShopifyAnalytics.meta.product.variants[0].id); } catch (err) { }
      return null;
    }

    function wrappers() {
      return document.querySelectorAll('.swym-atw-btn-wrapper');
    }

    function paint(saved) {
      wrappers().forEach(function (w) {
        w.classList.toggle('nicomore-hearted', saved);
      });
    }

    function setBusy(on) {
      busy = on;
      wrappers().forEach(function (w) {
        w.classList.toggle('nicomore-heart-busy', on);
      });
    }

    function withList(fn) {
      try {
        swat.fetch(function (items) { fn(items || []); });
      } catch (err) { fn(null); }
    }

    /* v5.2: 追加時に商品名・画像・価格を渡すための商品情報取得（ページごとに1回だけ）。
       これを渡さないと Swym の通知・お気に入り一覧がページ表題や壊れ画像で表示される
       （実測: 通知が「商品名 – にこもあーる」+ 画像切れ + 素の Notification 表示になった） */
    var productJson = null;
    function withProductJson(fn) {
      if (productJson) { fn(productJson); return; }
      fetch(location.pathname + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { productJson = p; fn(p); })
        .catch(function () { fn(null); });
    }

    function sync() {
      var pid = productId();
      if (!pid) return;
      withList(function (items) {
        if (!items) return;
        paint(items.some(function (it) { return String(it.empi) === pid; }));
      });
    }

    /* 初回の照合は Swym 側の初期化例外に巻き込まれて空振りすることがある
       （実測: 読み込み時の multipleLists 例外と同じ応答処理列で callback が
         呼ばれないまま死ぬ）ため、時間差で数回照合し直す */
    sync();
    setTimeout(sync, 2000);
    setTimeout(sync, 6000);
    setTimeout(sync, 12000);

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      /* v5.4→v5.5: wrapper は「カートに入れる」ボタンまで内包していることを実測。
         カートボタン本体のクリックだけ素通しし、wrapper 内の他（ハート本体 +
         その周りの余白）はすべて引き受ける。v5.4 の button.atw-button 限定だと
         余白タップが Swym 側の壊れた処理に流れ、削除は実行されるのに
         塗り直しが走らない（横田実機: 削除トースト + 塗り残留） */
      var wrap = e.target.closest('.swym-atw-btn-wrapper');
      if (!wrap) return;
      if (e.target.closest('button[name="add"], .product-form__submit')) return;
      if (!wrap.querySelector('button.atw-button')) return;
      var pid = productId();
      if (!pid) return; /* 商品ページ以外は素通し（ハートは商品ページにしか無い） */

      /* 壊れた Swym 側のクリック処理に渡さない（操作が反転しないため）。
         stopImmediatePropagation は document に後から登録された別の処理も止める */
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      if (busy) return;

      /* v5.5: クリック時点の見た目（= 直近の実リスト）から意図を確定する。
         Swym 側のリスナーが先に動いて既に追加/削除が済んでいた場合でも、
         意図と逆の操作で打ち消してしまわない（「消したのに塗りが残る」対策） */
      var intentRemove = wrap.classList.contains('nicomore-hearted');
      setBusy(true);

      var done = function () {
        setBusy(false);
        sync();
        setTimeout(sync, 1500); /* サーバー反映の遅れ対策の再確認 */
        setTimeout(sync, 4000); /* Swym 側リスナーが遅れて動いた場合の最終確認 */
      };

      /* v5.3: 操作をクリックイベントの処理中に始めない。
         クリック文脈内で Swym API を呼ぶと Swym の計測処理が暴走し
         主スレッドが約11秒停止することを実測（心拍計測 最大間隔 11,001ms）。
         タイマーで一拍置いてクリック文脈の外で実行すると回避できる */
      setTimeout(function () {
      withList(function (items) {
        if (!items) { done(); return; }
        var current = items.filter(function (it) { return String(it.empi) === pid; });
        try {
          if (intentRemove) {
            if (current.length) {
              /* サーバーに保存されている item をそのまま渡す（全項目が揃っている） */
              swat.removeFromWishList(current[0], done, done);
            } else {
              done(); /* 既に外れている（Swym 側が先に削除済み）→ 塗り直しだけ */
            }
          } else if (current.length) {
            done(); /* 既に入っている（Swym 側が先に追加済み）→ 塗り直しだけ */
          } else {
            var vid = variantId();
            withProductJson(function (p) {
              var payload = {
                empi: Number(pid),
                epi: vid ? Number(vid) : undefined,
                du: location.origin + location.pathname
              };
              if (p) {
                payload.dt = p.title;
                if (p.featured_image) {
                  payload.iu = (p.featured_image.indexOf('//') === 0 ? 'https:' : '') + p.featured_image;
                }
                var v = null;
                if (vid && p.variants) {
                  p.variants.forEach(function (x) { if (String(x.id) === String(vid)) v = x; });
                }
                var cents = v ? v.price : p.price;
                if (typeof cents === 'number') payload.pr = cents / 100;
              }
              try { swat.addToWishList(payload, done, done); } catch (err) { done(); }
            });
          }
        } catch (err) { done(); }
      });
      }, 0);
    }, true);
  }

  if (window._swat) {
    start(window._swat);
  } else {
    // 公式の登録簿にも積みつつ（消費する実装なら即動く）、_swat をポーリングで待つ
    (window.SwymCallbacks = window.SwymCallbacks || []).push(start);
    var tries = 0;
    var timer = setInterval(function () {
      if (window._swat) {
        clearInterval(timer);
        start(window._swat);
      } else if (++tries > 40) {
        clearInterval(timer);
      }
    }, 500);
  }
})();
